import cx from 'classnames';

// Utils
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  getButtonStylesAsClassName,
} from '@components/button';

export const getLinkStylesAsClassName = (
  dark?: boolean,
  color?: ButtonColor
): string => {
  return cx(
    'font-bold',
    'underline',
    // 'active:no-underline',
    'hover:cursor-pointer',
    'focus:cursor-pointer',
    {
      'text-gray-main hover:text-gray-dark focus:text-gray-dark active:text-gray-xlight':
        color === 'gray',
      'text-primary-main hover:text-primary-dark focus:text-primary-dark active:text-primary-xlight':
        color === 'primary',
      'text-white hover:text-white focus:text-white active:text-white':
        !color && dark,
      // 'text-secondary-main hover:text-secondary-dark focus:text-secondary-dark active:text-secondary-dark':
      //   !color && !dark,
    }
  );
};

export const getLinkButtonStylesAsClassName = (
  isFullWidth: boolean,
  color: ButtonColor,
  size: ButtonSize,
  variant: ButtonVariant,
  isLoading: boolean,
  isDisabled: boolean
): string =>
  getButtonStylesAsClassName({
    isFullWidth: isFullWidth,
    color: color,
    size: size,
    variant: variant,
    disabled: isDisabled,
    isLoading: isLoading,
  });
